<template style="width:100%;height:100%">
  <div class="page_chili">
    <el-row style="text-align: right">
      <el-col>
        <el-select
          v-model="selectedArea"
          style=""
          class="block-top-button-field"
          placeholder
          @change="refreshDataOnChange()"
        >
          <el-option
            v-for="item in options3"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="selectedBU"
          style=""
          class="block-top-button-field"
          placeholder="所有BU"
          @change="refreshDataOnChange()"
        >
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="16" style="height: 700px; padding: 1px">
        <el-row style="text-align: center">
          <el-col :span="8" style="padding-left: 30px">
            <div style="width: 100%; height: 100%">
              <div id="Page8_1" style="width: 240px; height: 240px"></div>
            </div>
          </el-col>
          <el-col :span="8" style="">
            <div id="Page8_3" style="width: 240px; height: 240px"></div>
          </el-col>
          <el-col :span="4">
            <div id="Page8_4" style="width: 240px; height: 240px"></div>
          </el-col>
        </el-row>
        <el-row style="width: 100%; border: 1px; height: 50%" id="aaa">
          <div id="Page8_mian_1" style="width: 1000px; height: 400px"></div>
        </el-row>
      </el-col>
      <el-col :span="7" style="height: 100%">
        <el-row style="text-align: center; padding: 0, 20">
          <span class="h4title">本站经济运行评估</span>
          <br />
          <span class="h4title">联络开关状态推荐</span>
          <br />
          <span id="showInfo" class="h4title">并排</span>
          <span id="showInfo2" class="h4title">解列</span>
          <br />
        </el-row>
        <el-row style="text-align: center; padding: 0, 20">
          <el-col :span="8" style="padding: 10px">
            <div
              style="width: 100%; height: 25px; padding: 10px; border: 1px red"
            >
              1#变
            </div>
            <div style="width: 100%; height: 25px; padding: 10px">预测有功</div>
            <div style="width: 100%; height: 25px; padding: 10px">Q2</div>
          </el-col>
          <el-col :span="8" style="padding: 10px">
            <div
              style="width: 100%; height: 25px; padding: 10px; border: 1px red"
            >
              铁损计算值
            </div>
            <div style="width: 100%; height: 25px; padding: 10px">###</div>
            <div style="width: 100%; height: 25px; padding: 10px">
              节省计算值
            </div>
            <div style="width: 100%; height: 25px; padding: 10px">###</div>
          </el-col>
          <el-col :span="8" style="padding: 10px">
            <div
              style="width: 100%; height: 25px; padding: 10px; border: 1px red"
            >
              2#变
            </div>
            <div style="width: 100%; height: 25px; padding: 10px">预测有功</div>
            <div style="width: 100%; height: 25px; padding: 10px">Q2</div>
          </el-col>
        </el-row>
        <el-row style="align-items: center;">
          <img
            src="../../Imag/0.png"
            id="img"
            style="width: 100%; height: 200px; border: 1px;display:none;margin"
          />
          <img
            src="../../Imag/1.png"
            id="img1"
            style="width: 100%; height: 200px; border: 1px;display:none;margin"
          />
          <img
            src="../../Imag/2.png"
            id="img2"
            style="width: 100%; height: 200px; border: 1px;display:none;margin"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import echarts from "echarts";
import request from "../../utils/request";
export default {
  data() {
    return {
      msg: "",
      sites: [{ name: "Runoob" }, { name: "Google" }, { name: "Taobao" }],
      radioPage3: "1",
      DatePage3: new Date(),
      DataValuePage3: [],
      titlePage: "",
      pveLoadStr: "",
      RatedCapacity: "",
      jp: "0",
      test: [],
      items: [
        { id: "一期1#变", content: "1", disabled: false, checked: true },
        { id: "一期2#变", content: "2", disabled: false, checked: false },
        { id: "三期1#变", content: "3", disabled: false, checked: false },
        { id: "二期1#变", content: "4", disabled: false, checked: false },
        { id: "二期2#变", content: "5", disabled: false, checked: false },
        { id: "金桥35kv主变", content: "6", disabled: false, checked: false },
        { id: "金桥10KV备用变", content: "7", disabled: false, checked: false },
      ],
      selectedBU: "1",
      selectedArea: "1",
      options3: [
        {
          value: "1",
          label: "金桥工厂",
        },
      ],
      options2: [
        {
          value: "1",
          label: "一期变压器组",
        },
      ],
      legendColor: false,
      mm: 5,
      dataset: [],
      NowYearTargetValue: [
        "10-16 1:00",
        "10-16 2:00",
        "10-16 3:00",
        "10-16 4:00",
        "10-16 5:00",
        "10-16 6:00",
        "10-16 7:00",
        "10-16 8:00",
        "10-16 9:00",
        "10-16 10:00",
        "10-16 11:00",
        "10-16 12:00",
      ],
    };
  },
  mounted() {
     this.GetData();
  },
  methods: {
    GetData() {
      var sizeForm = {
        ArrID: this.selectedBU,
      };
      request({
        url: "MeterTrans/GetPage8Data",
        method: "post",
        data: sizeForm,
      }).then((response) => {
        console.log(response.data);
        this.drawLine(response.data);
      });
    },
    drawLine(va) {
      //  基于准备好的dom，初始化echarts实例
      //   var chart1 = echarts.init(document.getElementById("main8"));
      var data = "";
      var data1 = "";
      var data3 = "";
      var data4 = "";
      this.dataset = va.lsArr;
      var kw1 = this.dataset[5][0];
      var kw2 = this.dataset[5][1];
      var kw3 = this.dataset[5][2];
      var jp = this.dataset[5][3];
      if (jp == "0") {
        document.getElementById("img").style.display = "block";
        document.getElementById("img1").style.display = "none";
        document.getElementById("img2").style.display = "none";
        document.getElementById("showInfo").style.display = "block";
        document.getElementById("showInfo").style.display = "none";
      }
      if (jp == "1") {
         document.getElementById("img").style.display = "none";
        document.getElementById("img1").style.display = "block";
        document.getElementById("img2").style.display = "none";
        document.getElementById("showInfo").style.display = "none";
        document.getElementById("showInfo2").style.display = "block";

      }
      if (jp == "2") {
        document.getElementById("img").style.display = "none";
        document.getElementById("img1").style.display = "none";
        document.getElementById("img2").style.display = "block";
        document.getElementById("showInfo").style.display = "none";
        document.getElementById("showInfo2").style.display = "block";

      }

      //实时图表
      var option_Page8_1 = {
        tooltip: {
          name: "1#变实时有功功率",
          formatter: "{a} <br/>{b} : {c}%",
        },
        title: {
          text: "1#变实时有功功率",
          left: "center",
          align: "right",
          textStyle: {
            fontWeight: "normal",
            color: "#FFF",
          },
        },
        grid: {
          top: "0",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        series: [
          {
            name: "功率",
            max: 2000,
            type: "gauge",
            detail: {
              formatter: "{value}KW",
              textStyle: {
                fontWeight: "normal",
                fontSize: 15,
              },
            },
            label: {
              normal: {
                formatter: "{b}:{c}: ({d}%)",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15,
                },
              },
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0.2, "lime"],
                  [0.8, "#1e90ff"],
                  [4, "#ff4500"],
                ],
                width: 3,
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            axisLabel: {
              // 坐标轴小标记
              distance: 8,
              fontSize: 12,
              formatter: function (v) {
                return v.toFixed(0);
              },
            },
            axisTick: {
              // 坐标轴小标记
              length: 15, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            splitLine: {
              // 分隔线
              length: 25, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                width: 3,
                color: "#fff",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            pointer: {
              // 分隔线
              shadowColor: "#fff", //默认透明
              shadowBlur: 5,
            },
            title: {
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: "bolder",
                fontSize: 20,
                fontStyle: "italic",
                color: "#fff",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },

            data: [kw1],
          },
        ],
      };
      var chart_Page8_1 = echarts.init(document.getElementById("Page8_1"));
      chart_Page8_1.setOption(option_Page8_1, true);

      //day month
      var option_Page8_3 = {
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        title: {
          text: "2#变实时有功功率",
          left: "center",
          align: "right",
          textStyle: {
            fontWeight: "normal",
            color: "#FFF",
          },
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        series: [
          {
            name: "2#变实时有功功率",
            type: "gauge",
            max: 2000,
            detail: {
              formatter: "{value}KW",
              textStyle: {
                fontWeight: "normal",
                fontSize: 15,
              },
            },
            label: {
              normal: {
                formatter: "{b}:{c}: ({d}%)",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15,
                },
              },
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0.2, "lime"],
                  [0.8, "#1e90ff"],
                  [4, "#ff4500"],
                ],
                width: 3,
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            axisLabel: {
              // 坐标轴小标记
              distance: 8,
              fontSize: 12,
              formatter: function (v) {
                return v.toFixed(0);
              },
            },
            axisTick: {
              // 坐标轴小标记
              length: 15, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            splitLine: {
              // 分隔线
              length: 25, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                width: 3,
                color: "#fff",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            pointer: {
              // 分隔线
              shadowColor: "#fff", //默认透明
              shadowBlur: 5,
            },
            title: {
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: "bolder",
                fontSize: 20,
                fontStyle: "italic",
                color: "#fff",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },

            data: [kw2],
          },
        ],
      };
      var chart_Page8_3 = echarts.init(document.getElementById("Page8_3"));
      chart_Page8_3.setOption(option_Page8_3, true);

      //day month
      var option_Page8_4 = {
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        title: {
          text: "负载率",
          left: "center",
          align: "right",
          textStyle: {
            fontWeight: "normal",
            color: "#FFF",
          },
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        series: [
          {
            name: "负载率",
            type: "gauge",
            detail: {
              formatter: "{value}%",
              textStyle: {
                fontWeight: "normal",
                fontSize: 15,
              },
            },
            label: {
              normal: {
                formatter: "{b}:{c}: ({d}%)",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15,
                },
              },
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0.2, "lime"],
                  [0.8, "#1e90ff"],
                  [4, "#ff4500"],
                ],
                width: 3,
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            axisLabel: {
              // 坐标轴小标记
              distance: 8,
              fontSize: 12,
              formatter: function (v) {
                return v.toFixed(0);
              },
            },
            axisTick: {
              // 坐标轴小标记
              length: 15, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            splitLine: {
              // 分隔线
              length: 25, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                width: 3,
                color: "#fff",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            pointer: {
              // 分隔线
              shadowColor: "#fff", //默认透明
              shadowBlur: 5,
            },
            title: {
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: "bolder",
                fontSize: 20,
                fontStyle: "italic",
                color: "#fff",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },

            data: [kw3],
          },
        ],
      };
      var chart_Page8_4 = echarts.init(document.getElementById("Page8_4"));
      chart_Page8_4.setOption(option_Page8_4, true);

      var Page8_line1_option = {
        tooltip: {
          trigger: "axis",
          formatter:
            "{b}<br />{a0}: {c0}<br />{a1}: {c1}<br/>{a2}:{c2}<br/>{a3}:{c3}",
          axisPointer: {
            type: "shadow",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          textStyle: {
            color: "#fff",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12,
          },
        },
        grid: {
          left: "3%",
          right: "1%",
          bottom: "5%",
          containLabel: true,
        },
        legend: {
          x: "right",
          itemGap: 16,
          itemWidth: 18,
          itemHeight: 10,
          data: [
            {
              name: "功率",
            },
            {
              name: "功率因数",
            },
          ],
          textStyle: {
            color: "#a8aab0",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12,
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.dataset[4],
            axisLine: {
              lineStyle: {
                color: "#0087ED",
                width: 1, //这里是为了突出显示加上的
              },
            },
            axisLabel: {
              textStyle: {
                color: "#078ceb",
                fontStyle: "normal",
                fontFamily: "微软雅黑",
                fontSize: 12,
              },
              rotate: 50,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#7f8fa4",
                opacity: 0.2,
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            left: "9%",
            bottom: -5,
            start: 0,
            end: 30, //初始化滚动条
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "功率",
            nameTextStyle: {
              color: "#fff",
            },
            splitNumber: 5,
            axisLine: {
              lineStyle: {
                color: "#0087ED",
                width: 1, //这里是为了突出显示加上的
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontStyle: "normal",
                fontFamily: "微软雅黑",
                fontSize: 12,
              },
            },
            axisLine: {
              show: true,
              color: "#7f8fa4",
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: ["#fff"],
                opacity: 0.06,
              },
            },
          },
        ],
        series: [
          {
            name: "1#变功率",
            type: "bar",
            stack: "123",
            data: this.dataset[0],
            barWidth: 10,
            barGap: 0,
            itemStyle: {
              normal: {
                show: true,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#75E35E",
                  },
                  {
                    offset: 1,
                    color: "#75E35E",
                  },
                ]),
              },
            },
          },
          {
            name: "2#变功率",
            type: "bar",
            stack: "123",
            data: this.dataset[1],
            barWidth: 10,
            barGap: 0,
           itemStyle: {
              normal: {
                show: true,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#8a5ee3",
                  },
                  {
                    offset: 1,
                    color: "#8a5ee3",
                  },
                ]),
              },
            },
          },
          {
            name: "预测功率",
            type: "line",
            data: this.dataset[3],
            color: "#75E35E",
          },
          {
            name: "1#与2#功率中位数",
            type: "line",
            data: this.dataset[2],
            color: "#8a5ee3",
          },
        ],
      };
      var chartPage8_line1 = echarts.init(
        document.getElementById("Page8_mian_1")
      );
      chartPage8_line1.setOption(Page8_line1_option, true);
      chartPage8_line1.resize();
    },
  },
};
</script>
<style>
@import "./page.css";
</style>
<style lang="less">
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.block-top-button-content {
  flex: 1;
  height: 3%;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-left: 20px;
}
.block-top-bottom-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-left: 20px;
}
.block-top-mid {
  height: 35%;
  display: flex;
  flex-grow: 0;
  box-sizing: border-box;
  padding-bottom: 20px;
}
.block-top-button {
  height: 5%;
  display: flex;
  flex-grow: 0;
  box-sizing: border-box;
  padding-bottom: 20px;
}
.el-select .el-input__inner {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
}
.block-top-button-field {
  margin-top: 15px;
  margin-left: 10px;
}
</style>